var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopNavUnblock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#E1E1E1",
    cx: 14,
    cy: 14,
    r: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 4.083A13.938 13.938 0 0014 0c-3.74 0-7.255 1.45-9.9 4.083A13.82 13.82 0 000 13.941a13.82 13.82 0 004.1 9.857A13.938 13.938 0 0014 27.88c3.74 0 7.255-1.45 9.9-4.083A13.82 13.82 0 0028 13.94a13.82 13.82 0 00-4.1-9.858zM14 1.394a12.59 12.59 0 019.043 3.82L4.04 21.614A12.449 12.449 0 011.4 13.941C1.4 7.022 7.052 1.394 14 1.394zm0 25.093a12.59 12.59 0 01-9.043-3.82l19.004-16.4A12.449 12.449 0 0126.6 13.94c0 6.918-5.652 12.546-12.6 12.546z",
    fill: "#414042",
    fillRule: "nonzero"
  }))));
}

export default SvgTopNavUnblock;